<template>
  <!-- will change url query: section=number -->
  <!-- <PageMenu :sections="sections">
    something in menu-content
  </PageMenu> -->
  <div class="menu">
    <div class="menu-head">
      <div class="menu-head__title">Switch Section</div>
      <div class="menu-head__items">
        <div
          v-for="(section, i) in sections"
          :key="section.name"
          class="menu-head__item hoverThenShowAddButton"
          :class="{ active: Number($route.query.section) == i }"
          style="position: relative"
          @click.self="$router.replace({ query: { section: String(i) } })"
        >
          <span
            @click.self="$router.replace({ query: { section: String(i) } })"
            >{{ section.name }}</span
          >
          <span
            v-if="section.name == 'Product Video'"
            class="addButton"
            style="position: absolute; right: 10%;"
            @click="$emit('add-product-video')"
          >
            <v-icon color="brand-600">add_circle</v-icon>
          </span>
        </div>
      </div>
    </div>
    <div class="menu-content">
      <!-- <component :is="sectionView"></component> -->
      <slot>選單內容</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
      default: function validateSections() {
        return [{ name: 'Product Spec' }];
      },
    },
  },
  mounted() {
    const sectionQuery = this.$route.query.section;
    if (sectionQuery === undefined || sectionQuery === null) {
      this.$router.replace({ query: { section: '0' } });
    }
  },
};
</script>

<style lang="scss">
.hoverThenShowAddButton {
  .addButton {
    display: none;
    position: relative;
  }
  &:hover {
    .addButton {
      display: inline;
      &:hover:before {
        content: '新增Section';
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -40px;
        left: 50%;
        transform: translateX(-50%);
        width: 78px;
        height: 28px;
        font-size: 12px;
        line-height: 16px;
        border-radius: 3px;
        background-color: #353e4d;
        color: white;
      }
    }
  }
}
</style>
